module.exports = __webpack_public_path__ + "static/media/سیستم-کنترل-اتمسفر-e1519223351794.c66f820d.jpg";